import { render, staticRenderFns } from "./ColorSlider.vue?vue&type=template&id=61b7eadf&"
import script from "./ColorSlider.vue?vue&type=script&lang=js&"
export * from "./ColorSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/utils/gradualSelect/ColorSlider.vue"
export default component.exports